import RedirectMap from "commons/components/RedirectMap";

import { SitemapItemType, SitemapType } from "commons/types/sitemap";

import { ConfigContextType } from "context/config";

import ElencoCataloghi from "pages/cataloghi/ElencoCataloghi";
import ModificaCatalogo from "pages/cataloghi/ModificaCatalogo";
import NuovoCatalogo from "pages/cataloghi/NuovoCatalogo";
import ElencoCatMateriali from "pages/categorie-materiali/ElencoCatMateriali";
import ModificaCatMateriale from "pages/categorie-materiali/ModificaCatMateriale";
import NuovaCatMateriale from "pages/categorie-materiali/NuovaCatMateriale";
import ElencoCategorie from "pages/categorie/ElencoCategorie";
import ModificaCategoria from "pages/categorie/ModificaCategoria";
import NuovaCategoria from "pages/categorie/NuovaCategoria";
import ElencoCmNotizie from "pages/cmNotizie/ElencoCmNotizie";
import ModificaCmNotizia from "pages/cmNotizie/ModificaCmNotizia";
import NuovaCmNotizia from "pages/cmNotizie/NuovaCmNotizia";
import ElencoCollezioni from "pages/collezioni/ElencoCollezioni";
import ModificaCollezione from "pages/collezioni/ModificaCollezione";
import NuovaCollezione from "pages/collezioni/NuovaCollezione";
import Dashboard from "pages/Dashboard";
import ElencoDocumenti from "pages/documenti/ElencoDocumenti";
import ModificaDocumento from "pages/documenti/ModificaDocumento";
import NuovoDocumento from "pages/documenti/NuovoDocumento";
import ElencoMateriali from "pages/materiali/ElencoMateriali";
import ModificaMateriale from "pages/materiali/ModificaMateriale";
import NuovoMateriale from "pages/materiali/NuovoMateriale";
import ElencoNews from "pages/news/ElencoNews";
import ModificaNews from "pages/news/ModificaNews";
import NuovaNews from "pages/news/NuovaNews";
import ElencoOfferte from "pages/offerte/ElencoOfferte";
import ModificaOfferta from "pages/offerte/ModificaOfferta";
import NuovaOfferta from "pages/offerte/NuovaOfferta";
import ElencoPagine from "pages/pagine/ElencoPagine";
import ModificaPagina from "pages/pagine/ModificaPagina";
import NuovaPagina from "pages/pagine/NuovaPagina";
import ElencoPartner from "pages/partner/ElencoPartner";
import ModificaPartner from "pages/partner/ModificaPartner";
import NuovoPartner from "pages/partner/NuovoPartner";
import ModificaPopup from "pages/popup/ModificaPopup";
import ElencoProdotti from "pages/prodotti/ElencoProdotti";
import ModificaProdotto from "pages/prodotti/ModificaProdotto";
import NuovoProdotto from "pages/prodotti/NuovoProdotto";
import ElencoProgetti from "pages/progetti/ElencoProgetti";
import ModificaProgetto from "pages/progetti/ModificaProgetto";
import NuovoProgetto from "pages/progetti/NuovoProgetto";
import ElencoProgettiRugiano from "pages/progettiRugiano/ElencoProgettiRugiano";
import ModificaProgettoRugiano from "pages/progettiRugiano/ModificaProgettoRugiano";
import NuovoProgettoRugiano from "pages/progettiRugiano/NuovoProgettoRugiano";
import ElencoShowroom from "pages/showroom/ElencoShowroom";
import ModificaShowroom from "pages/showroom/ModificaShowroom";
import NuovoShowroom from "pages/showroom/NuovoShowroom";
import ElencoSottoCatMateriali from "pages/sottocategorie-materiali/ElencoSottoCatMateriali";
import ModificaSottoCatMateriale from "pages/sottocategorie-materiali/ModificaSottoCatMateriale";
import NuovaSottoCatMateriale from "pages/sottocategorie-materiali/NuovaSottoCatMateriale";
import ElencoTemplates from "pages/templates/ElencoTemplates";
import ModificaTemplate from "pages/templates/ModificaTemplate";
import NuovoTemplate from "pages/templates/NuovoTemplate";
import ElencoOfferteSpeciali from "pages/terrazzaretica/ElencoOfferteSpeciali";
import ModificaOffertaSpeciale from "pages/terrazzaretica/ModificaOffertaSpeciale";
import NuovaOffertaSpeciale from "pages/terrazzaretica/NuovaOffertaSpeciale";
import Tariffe from "pages/terrazzaretica/Tariffe";

import { Authority } from "types/api/user";

export const getSitemap = (config: ConfigContextType): SitemapType => {
    const mainGroupItems: SitemapItemType[] = [
        {
            label: "Dashboard",
            path: "/dashboard",
            element: <Dashboard />,
            dontShowPathWay: true,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
        },
    ];

    if (config.features.includes("prodotti")) {
        mainGroupItems.push({
            label: "Gestione prodotti",
            path: "/gestione-prodotti",
            element: <RedirectMap />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Prodotti",
                    path: "/prodotti",
                    element: <ElencoProdotti />,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                    children: [
                        {
                            label: "Nuovo prodotto",
                            path: "/nuovo",
                            element: <NuovoProdotto />,
                            dontShowInMenu: true,
                            maxWidthUnset: true,
                            neededAuthorities: [Authority.USER],
                        },
                        {
                            label: "Modifica prodotto",
                            path: "/:productId/modifica",
                            element: <ModificaProdotto />,
                            dontShowInMenu: true,
                            maxWidthUnset: true,
                            neededAuthorities: [Authority.USER],
                        },
                    ],
                },
                {
                    label: "Categorie",
                    path: "/categorie",
                    element: <ElencoCategorie />,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                    children: [
                        {
                            label: "Nuova Categoria",
                            path: "/nuova",
                            element: <NuovaCategoria />,
                            dontShowInMenu: true,
                            extendedWidth: true,
                            neededAuthorities: [Authority.USER],
                        },
                        {
                            label: "Modifica Categoria",
                            path: "/:categoryId/modifica",
                            element: <ModificaCategoria />,
                            dontShowInMenu: true,
                            extendedWidth: true,
                            neededAuthorities: [Authority.USER],
                        },
                    ],
                },
                {
                    label: "Collezioni",
                    path: "/collezioni",
                    element: <ElencoCollezioni />,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                    children: [
                        {
                            label: "Nuova collezione",
                            path: "/nuova",
                            element: <NuovaCollezione />,
                            dontShowInMenu: true,
                            extendedWidth: true,
                            neededAuthorities: [Authority.USER],
                        },
                        {
                            label: "Modifica collezione",
                            path: "/:collectionId/modifica",
                            element: <ModificaCollezione />,
                            dontShowInMenu: true,
                            extendedWidth: true,
                            neededAuthorities: [Authority.USER],
                        },
                    ],
                },
            ],
        });
    }

    if (config.features.includes("materiali")) {
        mainGroupItems.push({
            label: "Gestione materiali",
            path: "/gestione-materiali",
            element: <RedirectMap />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Materiali",
                    path: "/materiali",
                    element: <ElencoMateriali />,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                    children: [
                        {
                            label: "Nuovo materiale",
                            path: "/nuovo",
                            element: <NuovoMateriale />,
                            dontShowInMenu: true,
                            extendedWidth: true,
                            neededAuthorities: [Authority.USER],
                        },
                        {
                            label: "Modifica materiale",
                            path: "/:materialId/modifica",
                            element: <ModificaMateriale />,
                            dontShowInMenu: true,
                            extendedWidth: true,
                            neededAuthorities: [Authority.USER],
                        },
                    ],
                },
                {
                    label: "Categorie",
                    path: "/categorie",
                    element: <ElencoCatMateriali />,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                    children: [
                        {
                            label: "Nuova categoria",
                            path: "/nuova",
                            element: <NuovaCatMateriale />,
                            dontShowInMenu: true,
                            extendedWidth: true,
                            neededAuthorities: [Authority.USER],
                        },
                        {
                            label: "Modifica categoria",
                            path: "/:materialCategoryId/modifica",
                            element: <ModificaCatMateriale />,
                            dontShowInMenu: true,
                            extendedWidth: true,
                            neededAuthorities: [Authority.USER],
                        },
                    ],
                },
                {
                    label: "Sottocategorie",
                    path: "/sotto-categorie",
                    element: <ElencoSottoCatMateriali />,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                    children: [
                        {
                            label: "Nuova sottocategoria",
                            path: "/nuova",
                            element: <NuovaSottoCatMateriale />,
                            dontShowInMenu: true,
                            extendedWidth: true,
                            neededAuthorities: [Authority.USER],
                        },
                        {
                            label: "Modifica sottocategoria",
                            path: "/:materialSubcategoryId/modifica",
                            element: <ModificaSottoCatMateriale />,
                            dontShowInMenu: true,
                            extendedWidth: true,
                            neededAuthorities: [Authority.USER],
                        },
                    ],
                },
            ],
        });
    }

    if (config.features.includes("news")) {
        mainGroupItems.push({
            label: "News",
            path: "/news",
            element: <ElencoNews />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Nuova news",
                    path: "/nuova",
                    element: <NuovaNews />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
                {
                    label: "Modifica news",
                    path: "/:newsId/modifica",
                    element: <ModificaNews />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
            ],
        });
    }

    if (config.features.includes("showroom")) {
        mainGroupItems.push({
            label: "Showroom",
            path: "/showroom",
            element: <ElencoShowroom />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Nuovo showroom",
                    path: "/nuovo",
                    element: <NuovoShowroom />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
                {
                    label: "Modifica showroom",
                    path: "/:showroomId/modifica",
                    element: <ModificaShowroom />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
            ],
        });
    }

    if (config.features.includes("cataloghi")) {
        mainGroupItems.push({
            label: "Cataloghi",
            path: "/cataloghi",
            element: <ElencoCataloghi />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Nuovo catalogo",
                    path: "/nuovo",
                    element: <NuovoCatalogo />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
                {
                    label: "Modifica catalogo",
                    path: "/:catalogId/modifica",
                    element: <ModificaCatalogo />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
            ],
        });
    }

    if (config.features.includes("progetti-rugiano")) {
        mainGroupItems.push({
            label: "Progetti",
            path: "/progetti-rugiano",
            element: <ElencoProgettiRugiano />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Nuovo progetto",
                    path: "/nuovo",
                    element: <NuovoProgettoRugiano />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
                {
                    label: "Modifica progetto",
                    path: "/:projectId/modifica",
                    element: <ModificaProgettoRugiano />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
            ],
        });
    }

    if (config.features.includes("lavora-con-noi")) {
        mainGroupItems.push({
            label: "Lavora con noi",
            path: "/lavora-con-noi",
            element: <ElencoOfferte />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Nuova offerta",
                    path: "/nuova-offerta",
                    element: <NuovaOfferta />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
                {
                    label: "Modifica offerta",
                    path: "/:workOfferId/modifica-offerta",
                    element: <ModificaOfferta />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
            ],
        });
    }

    if (config.features.includes("progetti")) {
        mainGroupItems.push({
            label: "Progetti",
            path: "/progetti",
            element: <ElencoProgetti />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Nuovo progetto",
                    path: "/nuovo",
                    element: <NuovoProgetto />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
                {
                    label: "Modifica progetto",
                    path: "/:projectId/modifica",
                    element: <ModificaProgetto />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
            ],
        });
    }

    if (config.features.includes("tariffe")) {
        mainGroupItems.push({
            label: "Tariffe",
            path: "/tariffe",
            element: <Tariffe />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
        });
    }

    if (config.features.includes("offerte-speciali")) {
        mainGroupItems.push({
            label: "Offerte Speciali",
            path: "/offerte-speciali",
            element: <ElencoOfferteSpeciali />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Nuova offerta speciale",
                    path: "/nuova",
                    element: <NuovaOffertaSpeciale />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
                {
                    label: "Modifica offerta speciale",
                    path: "/:specialOfferId/modifica",
                    element: <ModificaOffertaSpeciale />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
            ],
        });
    }

    if (config.features.includes("cm-documenti")) {
        mainGroupItems.push({
            label: "Documenti",
            path: "/cm-documenti",
            element: <ElencoDocumenti />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Nuovo documento",
                    path: "/nuovo",
                    element: <NuovoDocumento />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
                {
                    label: "Modifica documento",
                    path: "/:documentId/modifica",
                    element: <ModificaDocumento />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
            ],
        });
    }

    if (config.features.includes("cm-notizie")) {
        mainGroupItems.push({
            label: "Notizie",
            path: "/cm-notizie",
            element: <ElencoCmNotizie />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Nuova notizia",
                    path: "/nuova",
                    element: <NuovaCmNotizia />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
                {
                    label: "Modifica notizia",
                    path: "/:cmNewsId/modifica",
                    element: <ModificaCmNotizia />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
            ],
        });
    }

    if (config.features.includes("partner")) {
        mainGroupItems.push({
            label: "Partners",
            path: "/partners",
            element: <ElencoPartner />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Nuovo partners",
                    path: "/nuovo",
                    element: <NuovoPartner />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
                {
                    label: "Modifica partners",
                    path: "/:partnerId/modifica",
                    element: <ModificaPartner />,
                    dontShowInMenu: true,
                    extendedWidth: true,
                    neededAuthorities: [Authority.USER],
                },
            ],
        });
    }

    if (config.features.includes("popup")) {
        mainGroupItems.push({
            label: "Popup",
            path: "/popup",
            element: <ModificaPopup />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
        });
    }

    if (config.features.includes("pagine")) {
        mainGroupItems.push({
            label: "Pagine",
            path: "/pagine",
            element: <ElencoPagine />,
            extendedWidth: true,
            neededAuthorities: [Authority.USER],
            children: [
                {
                    label: "Nuova pagina",
                    path: "/nuova",
                    element: <NuovaPagina />,
                    dontShowInMenu: true,
                    maxWidthUnset: true,
                    neededAuthorities: [Authority.USER],
                },
                {
                    label: "Modifica pagina",
                    path: "/:pageId/modifica",
                    element: <ModificaPagina />,
                    dontShowInMenu: true,
                    maxWidthUnset: true,
                    neededAuthorities: [Authority.USER],
                },
            ],
        });
    }

    if (config.features.includes("template")) {
        mainGroupItems.push({
            label: "Templates",
            path: "/templates",
            element: <ElencoTemplates />,
            extendedWidth: true,
            neededAuthorities: [Authority.ADMIN],
            children: [
                {
                    label: "Nuovo template",
                    path: "/nuovo",
                    element: <NuovoTemplate />,
                    dontShowInMenu: true,
                    maxWidthUnset: true,
                    neededAuthorities: [Authority.ADMIN],
                },
                {
                    label: "Modifica template",
                    path: "/:templateId/modifica",
                    element: <ModificaTemplate />,
                    dontShowInMenu: true,
                    maxWidthUnset: true,
                    neededAuthorities: [Authority.ADMIN],
                },
            ],
        });
    }

    const sitemap: SitemapType = [
        {
            groups: [
                {
                    items: mainGroupItems,
                },
                {
                    items: [
                        {
                            label: "Log out",
                            path: "/auth/logout",
                            neededAuthorities: [Authority.USER],
                        },
                    ],
                },
            ],
        },
    ];

    return sitemap;
};
